export type ColorMode = "light" | "dark";
export type ThemeValues = Record<ColorMode, string>;

export function theme(light: string, dark: string) {
  return function(props: any) {
    const mode = props.theme?.mode as ColorMode;
    const values = { light, dark };
    return values[mode];
  };
}

export const Styleguide = {
  fonts: {
    heading: {
      name: "Globotipo UI",
      settings: `'ss01' 1, 'ss02' 0, 'ss03' 0`
    },
    body: {
      name: "Open Sans",
      opensans_regular: "opensans-regular"
    }
  },

  fontSizes: {
    14: "0.875rem",
    16: "1rem",
    18: "1.125rem",
    20: "1.25rem",
    22: "1.375rem",
    24: "1.5rem",
    26: "1.625rem",
    28: "1.75rem",
    30: "1.875rem",
    32: "2rem",
    48: "3rem",
    56: "3.5rem",
    64: "4rem"
  },

  fontWeights: {
    regular: 400,
    minbold: 500,
    semibold: 600,
    bold: 700
  },

  breakpoints: {
    mobile: "0px",
    tablet: "480px",
    desktop: "768px",
    wide: "1024px"
  }
};

export const Colors = {
  white: "#FFFFFF",
  black: "#000000",
  gray: {
    100: "#F5F5F5",
    200: "#D8D8D8",
    300: "#666666",
    400: "#333333",
    500: "#191919"
  },
  blue: {
    100: "#005CDE",
    200: "#004CB8",
    300: "#003C91"
  },
  lightBlue: {
    100: "#99C3FF",
    200: "#5C9FFF",
    300: "#1F7CFF"
  },
  green: {
    100: "#008A00",
    200: "#006300",
    300: "#003800"
  },
  lightGreen: {
    100: "#40C440",
    200: "#309730",
    300: "#216921"
  },
  red: {
    100: "#D10000",
    200: "#A80000",
    300: "#800000"
  },
  lightRed: {
    100: "#FF9E9E",
    200: "#FF6060",
    300: "#FF2424"
  },
  orange: {
    100: "#BD5B00",
    200: "#964800",
    300: "#6B3400"
  },
  lightOrange: {
    100: "#FFB875",
    200: "#FF9029",
    300: "#DB6A00"
  }
} as const;

export default Styleguide;
